<template>
  <div>
    <div
      class="main"
      @click="
        () => {
          if (!openOut) onUpload()
        }
      "
    >
      <div @dragover="onDragOver" @drop="onDrop">
        <slot> </slot>
        <input
          ref="uploader"
          type="file"
          class="d-none"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .xlsx"
          @change="e => onFileChanged(e.target.files[0])"
        />
      </div>
    </div>
    <PopupImportExcel
      :headers="headers"
      :items="items"
      :error="error"
      @accept="accept"
      @cancel="cancel"
      @reUpload="onUpload"
      :autoClose="autoClose"
      ref="dialog"
    />
  </div>
</template>

<script>
import readXlsxFile from 'read-excel-file'
import { mapActions } from 'vuex'
import PopupImportExcel from './PopupImportExcel.vue'
export default {
  components: {
    PopupImportExcel
  },
  props: {
    xlsxFileSchema: {
      type: Object,
      require: true
    },
    autoClose: {
      type: Boolean,
      default: true
    },
    headers: {
      type: Array,
      default: () => [],
      require: true
    },
    openOut: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    validate: Function,
    isUseOriginTable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      items: [],
      selectedFile: null
    }
  },
  methods: {
    ...mapActions('upload', ['upload']),
    onUpload() {
      this.$refs.uploader.value = ''
      this.$refs.uploader.click()
    },
    cancel() {
      this.items = []
      this.$refs.uploader.value = ''
    },
    accept() {
      this.$emit('accept', { val: this.items, selectedFile: this.selectedFile })
      this.items = []
      this.$refs.uploader.value = ''
    },
    closePopupReview() {
      this.$refs['dialog'].cancel()
    },
    async onFileChanged(file) {
      this.selectedFile = file
      let readFileResult
      try {
        readFileResult = await readXlsxFile(this.selectedFile, { schema: this.xlsxFileSchema })
      } catch (error) {
        return this.$alert.error('Có lỗi xảy ra, vui lòng kiểm tra lại file')
      }
      if (readFileResult.errors.length !== 0) {
        const error = readFileResult.errors[0]
        this.$alert.error(
          `Lỗi Dòng ${error.row || ''} - Cột ${error.column || ''} - ${error.value || ''}: ${error.error || 'error'}`
        )
        return
      } else {
        try {
          const results = readFileResult.rows
          this.items = results
          if (this.validate) {
            await this.validate(results)
          }
          this.$emit('onUploadSuccess', this.items)
          if (this.isUseOriginTable) this.$refs['dialog'].openDialog(results)
        } catch (error) {
          this.$alert.error(error)
        }
      }
      this.$loading.active = false
    },
    onDragOver(event) {
      event.preventDefault()
    },
    onDrop(event) {
      event.preventDefault()
      const files = event.dataTransfer.files
      this.onFileChanged(files[0])
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  cursor: pointer;
}
</style>
